const ViewAllButton = ({ text, onClick }: { text: string; onClick: () => void }) => {
  return (
    <button
      className="mx-auto mt-3 block w-full rounded-[12px] border-[0.5px] border-border bg-[#f8f7f5] px-6 py-3 text-sm font-semibold text-primary"
      onClick={onClick}
    >
      {text}
    </button>
  )
}

export default ViewAllButton
